/*
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-11 18:18:56
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-13 17:32:28
 */
import Vue from "vue";
import Vuex from "vuex";
import moduleHome from "./home";
import moduleNews from "./news";
import moduleAbout from "./about";
import moduleSearch from "./search";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
/*线上环境不允许调试修改state*/
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    Home: moduleHome,
    News: moduleNews,
    About: moduleAbout,
    Search: moduleSearch
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          News: val.News,
          About: val.About,
          Search: val.Search
        };
      }
    })
  ],
  strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index.js